import { makeObservable, observable, runInAction } from "mobx";
import { RootStore } from "./RootStore";
import { TransportService } from "../services/TransportService";
import DataStore from "./DataStore";
import {
  Indications, Indication
} from "../models/lists/Indications";

class IndicationStore extends DataStore {
  rootStore: RootStore;
  indications: Indications | undefined = undefined;
  mappedIndications: Map<number, string> | undefined = undefined;

  constructor(transportService: TransportService, rootStore: RootStore) {
    super(transportService);
    this.rootStore = rootStore;

    makeObservable(this, {
      indications: observable,
      mappedIndications: observable,
      success: observable,
      error: observable
    });
  }

  setIndications(indications: Indications | undefined) {
    if(indications) {
      indications.sort((a:Indication, b:Indication) => a.name.localeCompare(b.name))
    }
    const newMap = new Map<number, string>();
    if(indications) {
      indications.forEach(i => {
        newMap.set(i.id, i.name);
      });
    }
    runInAction(() => {
      this.indications = indications ?? [];
      this.mappedIndications = newMap;
    });
  }

  getIndications = async () => {
    const token = await this.rootStore.keycloakStore.getRefreshedToken();
    if (!token) {
      return;
    }
    try {
      this.clearError("getIndications");
      this.setLoading("getIndications");
      const res = await this.transportService.getWithToken("/indications",
        token
      );
      this.setIndications(res.data.indications as Indications);
    } catch (e) {
      console.error(e);
      this.setError("getIndications");
      return;
    } finally {
      this.clearLoading("getIndications");
    }
  };
}

export default IndicationStore;
